import {HttpStatusCodes} from '../../util/uiconstants';
import initialstate from '../initialstate';

import {CLEAR_GO_TO_SOURCE_BY_IDS, GO_TO_SOURCE_FORM_BODIES, GO_TO_SOURCE_DOCUMENTS} from '../../actions/actiontypes';

import normalizeGTSDocuments from './normalizers/normalizeGTSDocuments';
import normalizeGTSFormBodies from './normalizers/normalizeGTSFormBodies';

export default (state = initialstate.goToSource, action) => {
	switch (action.type) {
		case GO_TO_SOURCE_FORM_BODIES: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					[action.id]: normalizeGTSFormBodies(action?.response, action?.restProps)
				};
			}
			return state;
		}

		case GO_TO_SOURCE_DOCUMENTS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					[action.id]: normalizeGTSDocuments(action?.response, action?.restProps)
				};
			}
			return state;
		}

		case CLEAR_GO_TO_SOURCE_BY_IDS: {
			if (action.ids) {
				let newState = {...state};
				action.ids.forEach((id) => {
					const {[id]: _, ...rest} = newState;
					newState = rest;
				});
				return newState;
			}
			return state;
		}

		default:
			return state;
	}
};
